const CAL_DOT_COM_TIME_ZONE = 'America/New_York';
const SLOT_DURATION_MINUTES = 20;
const MAX_SEATS_PER_SLOT = 9;
const BOOKING_START_TIME_HOUR = 6;
const BOOKING_START_TIME_MINUTE = 0;
const BOOKING_END_TIME_HOUR = 23;
const BOOKING_END_TIME_MINUTE = 0;

const DAY_GRID_MONTH = 'dayGridMonth';

export {
  CAL_DOT_COM_TIME_ZONE,
  SLOT_DURATION_MINUTES,
  MAX_SEATS_PER_SLOT,
  BOOKING_START_TIME_HOUR,
  BOOKING_START_TIME_MINUTE,
  BOOKING_END_TIME_HOUR,
  BOOKING_END_TIME_MINUTE,
  DAY_GRID_MONTH,
};
